<template>
  <footer id="footer" class=" is-mobile">
    <span class="">
      designed & develepod by chamara abyesekara
    </span>
  </footer>
</template>

<script>
  export default {
    name: "Footer"
  }
</script>

<style lang="scss" scoped>

@import '../../static/_variables.scss';

  #footer{
    background-color: $main-color;

    span {
      font-size: 11px;
      padding-left: 10px;
      padding-right: 10px;
    }




  }
</style>



// WEBPACK FOOTER //
// src/componests/Footer.vue